var _defs, _path, _path2, _path3, _path4, _g, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmpty(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 136.528,
    height: 113.105,
    viewBox: "0 0 136.528 113.105",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3280",
    "data-name": "Rectangle 3280",
    width: 136.528,
    height: 113.105,
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.912,
    y1: 0.024,
    x2: 0.062,
    y2: 0.942,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1c1c1c"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_28777",
    "data-name": "Group 28777",
    transform: "translate(-206.5 -138.299)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_28766",
    "data-name": "Group 28766",
    transform: "translate(206.5 138.299)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_28765",
    "data-name": "Group 28765",
    clipPath: "url(#clip-path)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_38089",
    "data-name": "Path 38089",
    d: "M103.306,112.624l-99.13-39.8a6.653,6.653,0,0,1-3.7-8.653l24.087-60a6.653,6.653,0,0,1,8.653-3.7l99.13,39.8a6.653,6.653,0,0,1,3.7,8.654l-24.087,59.995a6.653,6.653,0,0,1-8.653,3.7",
    transform: "translate(0 0)",
    fill: "#ffc31f"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_38090",
    "data-name": "Path 38090",
    d: "M134.311,125.505H27.489a6.654,6.654,0,0,1-6.653-6.653V54.2a6.653,6.653,0,0,1,6.653-6.653H134.311a6.653,6.653,0,0,1,6.653,6.653v64.65a6.654,6.654,0,0,1-6.653,6.653",
    transform: "translate(-13.134 -29.973)",
    fill: "#fc3"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_38091",
    "data-name": "Path 38091",
    d: "M20.836,133.709H140.964",
    transform: "translate(-13.134 -84.285)",
    fill: "none",
    stroke: "#fff369",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_38160",
    "data-name": "Path 38160",
    d: "M134.311,125.505H27.489a6.654,6.654,0,0,1-6.653-6.653V54.2a6.653,6.653,0,0,1,6.653-6.653H134.311a6.653,6.653,0,0,1,6.653,6.653v64.65a6.654,6.654,0,0,1-6.653,6.653",
    transform: "translate(-13.134 -29.974)",
    fill: "url(#linear-gradient)",
    style: {
      mixBlendMode: "soft-light",
      isolation: "isolate"
    }
  }), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_38092",
    "data-name": "Path 38092",
    d: "M118.04,47.929v77.89",
    transform: "translate(-74.408 -30.212)",
    fill: "none",
    stroke: "#fff369",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_29037",
    "data-name": "Group 29037",
    transform: "translate(10.233 7.627)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_458",
    "data-name": "Line 458",
    y1: 3.081,
    transform: "translate(103.392 74.824)",
    fill: "none",
    stroke: "#fff369",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_459",
    "data-name": "Line 459",
    y1: 3.267,
    transform: "translate(103.392 57.905)",
    fill: "none",
    stroke: "#fff369",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38161",
    "data-name": "Path 38161",
    d: "M10.05,2.8A4.833,4.833,0,0,0,5.644.5c-3.257,0-4.5,1.628-4.5,3.352S3.195,6.437,5.6,6.883c2.251.418,4.454.97,4.454,3.089S8.135,13.335,5.6,13.335a6.283,6.283,0,0,1-5.22-2.586",
    transform: "translate(97.547 61.201)",
    fill: "none",
    stroke: "#fff369",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.5
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_38094",
    "data-name": "Path 38094",
    d: "M60.449,127.651c2.051-8.894,6.429-13.657,8.647-15.707,5.507-5.088,12.531-7.161,15.177-7.942,7.716-2.277,10.655-2.22,14.118-4.412,3.317-2.1,5.573-6.469,1.588-10.412-3.593-3.556-7.788-.926-8.647-.529-5.3,2.446-11.186,11.886-11.824,13.942v-.013c-.638-2.056-6.523-11.5-11.824-13.942-.86-.4-5.055-3.026-8.648.53-3.984,3.943-1.728,8.313,1.588,10.412,3.463,2.192,6.4,2.135,14.118,4.412,2.646.781,9.67,2.853,15.177,7.942,2.219,2.05,6.6,6.812,8.648,15.707",
    transform: "translate(-35.877 -55.778)",
    fill: "none",
    stroke: "#fff369",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmpty);
export default __webpack_public_path__ + "static/media/empty.3b2e07e5cb69de65a1b6668ea3b8fb9c.svg";
export { ForwardRef as ReactComponent };